export interface Unit {
  id: string
  vchod: string
  patro: string
  kod: string
  typ: string
  kategorie: string
  uzitnaPlochM2: number
  balkonM2: number | null
  terasaM2: number | null
  predzahradkaM2: number | null
  stav: 'k dispozici' | 'rezervováno' | 'prodáno'
}

export const units: Unit[] = [
  // 1NP - Vchod A
  {
    id: '1',
    vchod: 'A',
    patro: '1NP',
    kod: 'A 1.1 T Z',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 58.26,
    balkonM2: 14.77,
    terasaM2: null,
    predzahradkaM2: 43.57,
    stav: 'k dispozici',
  },
  {
    id: '2',
    vchod: 'A',
    patro: '1NP',
    kod: 'A 1.2 T Z',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 75.09,
    balkonM2: 99.5,
    terasaM2: 21.2,
    predzahradkaM2: 27.85,
    stav: 'k dispozici',
  },
  {
    id: '3',
    vchod: 'A',
    patro: '1NP',
    kod: 'A 1.3 T Z',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 39.85,
    balkonM2: null,
    terasaM2: 23.12,
    predzahradkaM2: 45.72,
    stav: 'k dispozici',
  },
  {
    id: '4',
    vchod: 'A',
    patro: '1NP',
    kod: 'A 1.4 T Z',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 59.57,
    balkonM2: null,
    terasaM2: 30.87,
    predzahradkaM2: 82.57,
    stav: 'k dispozici',
  },
  {
    id: '5',
    vchod: 'A',
    patro: '1NP',
    kod: 'A 1.5 T Z',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 63.82,
    balkonM2: null,
    terasaM2: 5.94,
    predzahradkaM2: 36.15,
    stav: 'rezervováno',
  },

  // 1NP - Vchod B
  {
    id: '6',
    vchod: 'B',
    patro: '1NP',
    kod: 'B 1.1',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 33.07,
    balkonM2: 11.22,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '7',
    vchod: 'B',
    patro: '1NP',
    kod: 'B 1.2',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 55.0,
    balkonM2: null,
    terasaM2: 20.91,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '8',
    vchod: 'B',
    patro: '1NP',
    kod: 'B 1.3',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 40.18,
    balkonM2: 13.84,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '9',
    vchod: 'B',
    patro: '1NP',
    kod: 'B 1.4 T Z',
    typ: 'bytová jednotka',
    kategorie: '4+kk',
    uzitnaPlochM2: 94.4,
    balkonM2: null,
    terasaM2: 61.52,
    predzahradkaM2: 69.58,
    stav: 'k dispozici',
  },
  {
    id: '10',
    vchod: 'B',
    patro: '1NP',
    kod: 'B 1.5 T Z',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 34.7,
    balkonM2: null,
    terasaM2: 15.16,
    predzahradkaM2: 19.54,
    stav: 'prodáno',
  },
  {
    id: '11',
    vchod: 'B',
    patro: '1NP',
    kod: 'B 1.6',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 57.42,
    balkonM2: 10.71,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 1NP - Vchod C
  {
    id: '12',
    vchod: 'C',
    patro: '1NP',
    kod: 'C 1.1',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 70.98,
    balkonM2: null,
    terasaM2: 19,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '13',
    vchod: 'C',
    patro: '1NP',
    kod: 'C 1.2',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 63.27,
    balkonM2: null,
    terasaM2: 28.76,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '14',
    vchod: 'C',
    patro: '1NP',
    kod: 'C 1.3',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 55.92,
    balkonM2: null,
    terasaM2: 24,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '15',
    vchod: 'C',
    patro: '1NP',
    kod: 'C 1.4',
    typ: 'bytová jednotka',
    kategorie: '4+kk',
    uzitnaPlochM2: 133.03,
    balkonM2: null,
    terasaM2: 78.98,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '16',
    vchod: 'C',
    patro: '1NP',
    kod: 'C 1.5',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 49.54,
    balkonM2: null,
    terasaM2: 12.61,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 1NP - Vchod D
  {
    id: '17',
    vchod: 'D',
    patro: '1NP',
    kod: 'D 1.1',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 74.47,
    balkonM2: null,
    terasaM2: 20.24,
    predzahradkaM2: null,
    stav: 'rezervováno',
  },
  {
    id: '18',
    vchod: 'D',
    patro: '1NP',
    kod: 'D 1.2',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 34.17,
    balkonM2: null,
    terasaM2: 18.21,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '19',
    vchod: 'D',
    patro: '1NP',
    kod: 'D 1.3',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 34.17,
    balkonM2: null,
    terasaM2: 17.97,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '20',
    vchod: 'D',
    patro: '1NP',
    kod: 'D 1.4',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 69.76,
    balkonM2: null,
    terasaM2: 7.16,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '21',
    vchod: 'D',
    patro: '1NP',
    kod: 'D 1.5',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 71.84,
    balkonM2: null,
    terasaM2: 11.55,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 2NP - Vchod A
  {
    id: '22',
    vchod: 'A',
    patro: '2NP',
    kod: 'A 2.1',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 58.26,
    balkonM2: null,
    terasaM2: 12.19,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '23',
    vchod: 'A',
    patro: '2NP',
    kod: 'A 2.2',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 75.09,
    balkonM2: null,
    terasaM2: 27.85,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '24',
    vchod: 'A',
    patro: '2NP',
    kod: 'A 2.3',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 39.85,
    balkonM2: 4.41,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '25',
    vchod: 'A',
    patro: '2NP',
    kod: 'A 2.4',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 59.57,
    balkonM2: 5.62,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '26',
    vchod: 'A',
    patro: '2NP',
    kod: 'A 2.5',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 63.82,
    balkonM2: 4.42,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 2NP - Vchod B
  {
    id: '27',
    vchod: 'B',
    patro: '2NP',
    kod: 'B 2.1',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 33.07,
    balkonM2: 11.22,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '28',
    vchod: 'B',
    patro: '2NP',
    kod: 'B 2.2',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 55.0,
    balkonM2: 20.91,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '29',
    vchod: 'B',
    patro: '2NP',
    kod: 'B 2.3',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 40.18,
    balkonM2: 13.84,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '30',
    vchod: 'B',
    patro: '2NP',
    kod: 'B 2.4',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 94.4,
    balkonM2: 54.68,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'rezervováno',
  },
  {
    id: '31',
    vchod: 'B',
    patro: '2NP',
    kod: 'B 2.5',
    typ: 'bytová jednotka',
    kategorie: '4+kk',
    uzitnaPlochM2: 34.7,
    balkonM2: 13.64,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '32',
    vchod: 'B',
    patro: '2NP',
    kod: 'B 2.6',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 57.42,
    balkonM2: 10.71,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 2NP - Vchod C
  {
    id: '33',
    vchod: 'C',
    patro: '2NP',
    kod: 'C 2.1',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 70.97,
    balkonM2: 19,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '34',
    vchod: 'C',
    patro: '2NP',
    kod: 'C 2.2',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 63.27,
    balkonM2: 28.76,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '35',
    vchod: 'C',
    patro: '2NP',
    kod: 'C 2.3',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 55.92,
    balkonM2: 24,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '36',
    vchod: 'C',
    patro: '2NP',
    kod: 'C 2.4',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 133.03,
    balkonM2: 78.98,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '37',
    vchod: 'C',
    patro: '2NP',
    kod: 'C 2.5',
    typ: 'bytová jednotka',
    kategorie: '4+kk',
    uzitnaPlochM2: 49.54,
    balkonM2: 12.61,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 2NP - Vchod D
  {
    id: '38',
    vchod: 'D',
    patro: '2NP',
    kod: 'D 2.1',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 74.47,
    balkonM2: 20.24,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '39',
    vchod: 'D',
    patro: '2NP',
    kod: 'D 2.2',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 34.17,
    balkonM2: 18.21,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'prodáno',
  },
  {
    id: '40',
    vchod: 'D',
    patro: '2NP',
    kod: 'D 2.3',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 34.17,
    balkonM2: 17.97,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'prodáno',
  },
  {
    id: '41',
    vchod: 'D',
    patro: '2NP',
    kod: 'D 2.4',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 69.76,
    balkonM2: 7.16,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '42',
    vchod: 'D',
    patro: '2NP',
    kod: 'D 2.5',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 71.84,
    balkonM2: 11.55,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 3NP - Vchod A
  {
    id: '43',
    vchod: 'A',
    patro: '3NP',
    kod: 'A 3.1',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 58.26,
    balkonM2: 12.19,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '44',
    vchod: 'A',
    patro: '3NP',
    kod: 'A 3.2',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 75.09,
    balkonM2: 27.85,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '45',
    vchod: 'A',
    patro: '3NP',
    kod: 'A 3.3',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 39.85,
    balkonM2: 4.41,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '46',
    vchod: 'A',
    patro: '3NP',
    kod: 'A 3.4',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 59.57,
    balkonM2: 5.62,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '47',
    vchod: 'A',
    patro: '3NP',
    kod: 'A 3.5',
    typ: 'bytová jednotka',
    kategorie: '3+kk',
    uzitnaPlochM2: 63.82,
    balkonM2: 4.42,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },

  // 3NP - Vchod B
  {
    id: '48',
    vchod: 'B',
    patro: '3NP',
    kod: 'B 3.1',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 33.07,
    balkonM2: 20.91,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '49',
    vchod: 'B',
    patro: '3NP',
    kod: 'B 3.2',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 55.0,
    balkonM2: 13.84,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '50',
    vchod: 'B',
    patro: '3NP',
    kod: 'B 3.3',
    typ: 'bytová jednotka',
    kategorie: '2+kk',
    uzitnaPlochM2: 40.18,
    balkonM2: 54.68,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
  {
    id: '51',
    vchod: 'B',
    patro: '3NP',
    kod: 'B 3.4',
    typ: 'bytová jednotka',
    kategorie: '4+kk',
    uzitnaPlochM2: 94.4,
    balkonM2: 13.64,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'prodáno',
  },
  {
    id: '52',
    vchod: 'B',
    patro: '3NP',
    kod: 'B 3.5',
    typ: 'bytová jednotka',
    kategorie: '1+kk',
    uzitnaPlochM2: 34.7,
    balkonM2: 10.71,
    terasaM2: null,
    predzahradkaM2: null,
    stav: 'k dispozici',
  },
]

export function getUnitsByStatus(status: Unit['stav']): Unit[] {
  return units.filter((unit) => unit.stav === status)
}

export function getSoldOrReservedUnits(): Unit[] {
  return units.filter(
    (unit) => unit.stav === 'prodáno' || unit.stav === 'rezervováno',
  )
}

export function getAvailableUnits(): Unit[] {
  return units.filter((unit) => unit.stav === 'k dispozici')
}

export function formatArea(value: number | null): string {
  if (value === null) return '—'
  return `${value.toLocaleString('cs-CZ')} m²`
}
